<template>
  <el-row class="core_two_wrap">
    <el-col class="two_left">
      <div class="left_tit">
        数据管理与资源整合中枢：多维度协同治理平台
      </div>
      <div class="left_desc">
        通过数字化工具促进资源共享与组织升级
      </div>
      <el-row class="icon_wrap">
        <el-col class="icon_item">
          <div class="icon_title">30万+</div>
          <div class="icon_desc">校友信息</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">5万+</div>
          <div class="icon_desc">就业方向分析</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">动态维护</div>
          <div class="icon_desc">校友任职企业信息</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">潜在合作</div>
          <div class="icon_desc">一键发起联系</div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item">
          <div class="icon_title">68个地区</div>
          <div class="icon_desc">校友分会行业协会</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">200+</div>
          <div class="icon_desc">校企合作</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">125万+</div>
          <div class="icon_desc">商协会会员</div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item">
          <div class="icon_title">1200场+</div>
          <div class="icon_desc">举办活动</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">2300+</div>
          <div class="icon_desc">成果转化</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">100+</div>
          <div class="icon_desc">党务培训活动</div>
        </el-col>
        <el-col class="icon_item">
          <div class="icon_title">10000+</div>
          <div class="icon_desc">政策新闻</div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="two_right">
      <img src="@/assets/img/right2.png" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.core_two_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
  .two_left {
    width: 40%;
    padding: 20px 50px 20px 50px;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }
    .left_desc {
      color: #717171;
      padding: 30px 40px 20px 40px;
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        padding: 30PX 0;
        font-size: 1rem;
        line-height: 1.2rem;
      }
      span {
        color: #ffa400;
        font-size: 24px;
        padding: 0 10px;
        @media screen and (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }
    .icon_wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      &:nth-child(n+2){
        margin-top: -20px;
      }
      .icon_item {
        background: url('../../assets/img/types.png') 0 0 no-repeat;
        background-size: 100% 100%;
        width: 120px;
        height: 135px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-right: 10px;
        @media screen and (max-width: 768px) {
          width: 20%;
          height: 73PX;
          margin-right: 10PX;
        }
        .icon_title {
          color: #717171;
          font-size: 22px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 0.9rem;
            white-space: nowrap;
          }
        }
        .icon_desc {
          color: #717171;
          font-size: 14px;
          margin-top: 12px;
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .two_right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }
    img {
      width: 65%;
      margin-top: 70px;
    }
  }
}
</style>
